export default "__VITE_PUBLIC_ASSET__e50cca7f__"